const eventStyle = {
  searchdiv: {
    marginLeft: "80px",
  },

  tablehead: {
    backgroundColor: "#171942",
    color: "white",
  },
  tableheadercell: {
    color: "white",
  },
  dialogbox: {
    height: 500,
    width: 500,
  },
  disabledInput: {
    "& .MuiInputBase-root.Mui-disabled": {
      color: "black"
    }
  },
};


export default eventStyle;
